const { get, omit, pick, isEmpty } = require('lodash');

const { boxSizes } = require('../config');
const { idWithTenant } = require('../util');

const { entries } = Object;

const documentNumberHavings = {
  hasDocumentNumber: { label: '伝票番号あり', },
  noDocumentNumber: { label: '伝票番号なし', },
};

const statuses = {
  initial: { label: '入荷待ち', color: '', },
  unknown: { label: '不明', color: 'warning', },
  pending: { label: '確認', color: 'warning', },
  resubmitted: { label: '再入庫待ち', color: 'info', },
  processing: { label: '入庫中', color: 'warning', },
  received: { label: '入庫済み', color: 'secondary', },
};
const receivingOptions = {
  check: { label: '追加検品', billingLogType: 'receivingRequestCheckCounts', },
  set: { label: 'セット', billingLogType: 'receivingRequestSetsCount', },
  opp: { label: 'OPP梱包', billingLogType: 'receivingRequestOppsCount', },
  keepDocuments: { label: '納品書・明細書確認保管', billingLogType: 'receivingRequestKeepDocumentsCount', },
  requiredExpiration: { label: '要期限商品', billingLogType: 'receivingRequestRequiredExpirationCount', },
};
const setSizes = {
  none: { label: 'なし', },
  size80: { label: '80以下', },
  size120: { label: '100・120', },
  size160: { label: '140・160', },
};

const fields = ({ items = [], tenant, productsById = {} } = {}) => {
  return {
    documentNumber: {
      label: '伝票番号',
      type: 'string',
      validations: {
        format: v => (v || '').match(/^[a-zA-Z0-9,]*$/g),
      },
      placeholder: '半角英数字と半角カンマのみ',
    },
    scheduleDate: {
      label: '入荷予定日',
      type: 'date',
    },
    receivingOptionValues: {
      label: 'オプション',
      type: 'multiSelect',
      options: entries(receivingOptions).map(([k, _]) => ({ label: _.label, value: k, })),
      initialValue: [],
    },
    checkNote: {
      label: '検品依頼内容',
      type: 'text',
      hidden: _ => !(_.receivingOptionValues || []).includes('check'),
    },
    setNote: {
      label: 'セット内容',
      type: 'text',
      hidden: _ => !(_.receivingOptionValues || []).includes('set'),
    },
  };
};


const adminFields = ({ values } = {}) => {
  return {
    ...fields({ values }),
    ...(
      get(values, 'status') !== 'unknown' && {
        status: {
          label: 'ステータス',
          type: 'select',
          options: entries(omit(statuses, ['unknown'])).map(([k, _]) => ({ label: _.label, value: k })),
          validations: {
            required: _ => !isEmpty(_),
          },
        },
      }
    ),
    note: {
      label: '連絡メモ',
      type: 'text',
    },
    adminNote: {
      label: '管理者メモ',
      type: 'text',
    },
  };
};

module.exports = {
  fields,
  itemFields: ({ items = [], products = [], productsById = {} } = {}) => {
    return {
      productId: {
        label: '商品',
        type: 'select',
        options: products.map(_ => ({ label: `${idWithTenant(_.ref)} [${_.sku}] ${_.name}`, value: _.id })),
        validations: {
          required: _ => !isEmpty(_),
          unique: v => items.filter(_ => _.productId === v).length < 2,
        },
        placeholder: '商品名、SKU、ASIN、FNSKU、JANで検索できます(検索結果は最大300個まで表示されます)',
      },
      quantity: {
        label: '数量',
        type: 'integer',
        validations: {
          greaterThan0: _ => _ > 0,
        },
      },
    };
  },
  pendingItemFields: () => {
    return {
      boxSize: {
        label: 'サイズ',
        type: 'select',
        options: entries(boxSizes).map(([k, _]) => ({ label: _.label, value: k })),
        validations: {
          required: _ => !isEmpty(_),
        },
      },
      quantity: {
        label: '数量(箱)',
        type: 'integer',
        validations: {
          greaterThanOrEqualTo0: _ => _ >= 0,
        },
      },
    };
  },
  adminItemFields: () => {
    return {
    };
  },
  adminFields,
  unknownFields: ({ tenants = [], } = {}) => {
    return {
      tenantId: {
        label: 'テナント',
        type: 'select',
        options: tenants.map(_ => ({ label: `[${_.id}] ${_.name}`, value: _.id })),
        validations: {
          required: _ => !isEmpty(_),
        },
      },
      status: {
        label: 'ステータス',
        type: 'select',
        options: entries(pick(statuses, ['unknown'])).map(([k, _]) => ({ label: _.label, value: k })),
        initialValue: 'unknown',
        readOnly: _ => true,
      },
      ...omit(adminFields(), ['status', 'receivingOptionValues']),
      documentNumber: {
        label: '伝票番号',
        type: 'string',
        validations: {
          required: _ => !isEmpty(_),
        },
      },
      slipImages: {
        label: '伝票の写真',
        type: 'files',
        validations: {
          required: _ => !isEmpty(_),
        },
        inputProps: {
          accept: 'image/*',
        },
      },
      janImages: {
        label: 'JANか型番の写真',
        type: 'files',
        validations: {
          required: _ => !isEmpty(_),
        },
        inputProps: {
          accept: 'image/*',
        },
      },
    };
  },
  statuses,
  boxSizes,
  setSizes,
  receivingOptions,
  documentNumberHavings,
};
